import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Instagram, Youtube, Twitter } from "lucide-react";
import { POLICY_NAV } from "@/lib/policies";

export default function Footer() {
  return (
    <footer className="relative z-10 border-t border-white/10 bg-[#050505] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <Logo />
          <p className="mt-4 text-sm text-neutral-400 leading-relaxed max-w-xs">
            The trusted barber quality network. Where customers find quality, and barbers gain status, leads, and exposure.
          </p>
          <div className="mt-5 flex gap-4 text-neutral-400">
            <a href="#" aria-label="Instagram" className="hover:text-[#D4AF37] transition-colors"><Instagram size={18} /></a>
            <a href="#" aria-label="YouTube" className="hover:text-[#D4AF37] transition-colors"><Youtube size={18} /></a>
            <a href="#" aria-label="Twitter" className="hover:text-[#D4AF37] transition-colors"><Twitter size={18} /></a>
          </div>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest text-[#D4AF37] mb-4 font-mono">Explore</h4>
          <ul className="space-y-2.5 text-sm text-neutral-400">
            <li><Link to="/pricing" className="hover:text-white transition-colors">Pricing & Plans</Link></li>
            <li><Link to="/directory" className="hover:text-white transition-colors">Barber Directory</Link></li>
            <li><Link to="/reserve" className="hover:text-white transition-colors">Barbistry Reserve</Link></li>
            <li><Link to="/certification" className="hover:text-white transition-colors">Certification</Link></li>
            <li><Link to="/news" className="hover:text-white transition-colors">Industry News</Link></li>
            <li><Link to="/events" className="hover:text-white transition-colors">Education & Events</Link></li>
            <li><Link to="/advertising" className="hover:text-white transition-colors">Advertise</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest text-[#D4AF37] mb-4 font-mono">Legal</h4>
          <ul className="space-y-2.5 text-sm text-neutral-400">
            {POLICY_NAV.map(([slug, label]) => (
              <li key={slug}><Link to={`/policy/${slug}`} className="hover:text-white transition-colors">{label}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest text-[#D4AF37] mb-4 font-mono">Community</h4>
          <ul className="space-y-2.5 text-sm text-neutral-400">
            <li><Link to="/policy/community" className="hover:text-white transition-colors">Community Standards</Link></li>
            <li><Link to="/register" className="hover:text-white transition-colors">Join as a Barber</Link></li>
            <li><Link to="/register" className="hover:text-white transition-colors">List Your Shop</Link></li>
            <li><Link to="/register" className="hover:text-white transition-colors">Become a Vendor</Link></li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-neutral-500">
        <span>© {new Date().getFullYear()} Barbistry. All rights reserved.</span>
        <span className="font-mono">Quality. Trust. Craft.</span>
      </div>
    </footer>
  );
}
